import React, { useState, useContext, useEffect } from 'react';
import { PrimaryButton, ChoiceGroup, IconButton, ActionButton, mergeStyleSets, } from '@fluentui/react';
import htmr from 'htmr';
import Correct from './Correct';
import Incorrect from './Incorrect';
import Explanation from './Explanation';

function TrueFalse(props) {
    const [options, setOptions] = useState([]);
    const [selectedKey, setSelectedKey] = useState(props.value);

    useEffect(() => {
        props.data.answers.forEach((x, i) => {
            x.key = x.qnsAnswerId;
            x.text = x.label;
            x.isCorrect = x.isCorrect;
        })
        setOptions(props.data.answers)
    }, []);

    const _onChange = (e, option) => {
        setSelectedKey(option.key);
        props.setValueId(option.key)

    }

    return (
        <div className="flexcolumn displayflex flex1 prelative quiz-container">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
            <div className="displayflex flex1 width100" style={{ maxWidth: 600, marginTop: props.view ? 10 : 20 }}>
                <form className="default-form width100 question-wysiwyg">
                    <div class="form-group width100">
                       
                        <div class="flexcolumn mb10">
                            <ChoiceGroup selectedKey={selectedKey} options={options} onChange={_onChange} required={true} />
                        </div>
                    </div>
                </form>
            </div>
            {props.showExplanation && <Explanation setShowExplanation={props.setShowExplanation} data={props.data} callback={props.callback} complete={props.complete} />}
            {props.showCorrect && <Correct />}
            {props.showInCorrect && <Incorrect />}
        </div>
    );
}

export default TrueFalse;   